import { Context, Plugin } from '@nuxt/types'
import { formatDate } from '@mg/web-components/utils/date'
import { FormatDateType } from '@mg/web-components/utils/date/types'
import { GQLProductCollectionItems } from '~/graphql/__generated__/interfaces'
import { isGQLProduct } from '~/utils/productPagination/productPaginationGuards'

const createVueContext = (context: any) => {
  const vueCtx: Vue & Context = context
  return vueCtx
}

const translateProductVariantStickers: Plugin = (context, inject) => {
  inject(
    'translateProductVariantStickers',
    (item: GQLProductCollectionItems) => {
      if (!isGQLProduct(item)) {
        return item
      }

      const vueCtx = createVueContext(context)

      const redesignStickers = [
        'exclusive-price',
        'action',
        'sale',
        'bazaar',
        'stock-from',
        'new',
      ]

      return {
        ...item,
        mainVariant: {
          ...item.mainVariant,
          variantStickers:
            item.mainVariant?.variantStickers?.map((sticker) => {
              if (sticker.isFromConfig) {
                return sticker
              }
              const validRedesignSticker = redesignStickers.includes(
                sticker.name
              )
              if (!validRedesignSticker) {
                return
              }

              const text = sticker.date
                ? vueCtx?.$translateWithParams(`common.${sticker?.text}`, [
                    formatDate(sticker.date, FormatDateType.short),
                  ])
                : // @ts-ignore
                  context.app.i18n.t(`common.${sticker?.text}` ?? '') ?? ''
              return {
                isStock: sticker?.isStock ?? false,
                name: sticker?.name ?? '',
                text,
              }
            }) ?? [],
        },
      }
    }
  )
}

export default translateProductVariantStickers
